import {
  observable,
  computed,
  action,
  useStrict,
  runInAction,
  autorun,
  isObservable,
  isObservableArray,
  isObservableMap
} from "mobx";
import BaseStore from "./BaseStore";
import api from "../api/api";
import utils from "../utils/utils";

useStrict(true);

class StoreGlobal extends BaseStore {
  /*
  {
    cate: {
      "7": "法商内参",
      "8": "法商宝典",
      "10": "法商模板",
      "13": "法商头条",
      "18": "法商大单"
    },
    isopen: 1,
    note: "升级维护中。。。。。",
    version: {
      android: {
        version_code: "201803060",
        version: "3.2.0",
        is_must_upgrade: 1,
        downurl: "xxxx.foschool.com/apk/v3.1.4/fo.apk"
      },
      ios: { version: "3.2.0", is_must_upgrade: 0 }
    },
    pay: [
      { id: "cn.foschool.fszx.product18", price: 18, name: "18 立心值" },
      { id: "cn.foschool.fszx.product68", price: 68, name: "68 立心值" },
      { id: "cn.foschool.fszx.product98", price: 98, name: "98 立心值" },
      { id: "cn.foschool.fszx.product188", price: 188, name: "188 立心值" },
      { id: "cn.foschool.fszx.product588", price: 588, name: "588 立心值" },
      { id: "cn.foschool.fszx.product998", price: 998, name: "998 立心值" }
    ]
  }
   */
  @observable
  appConfig = {
    area: []
  };
  @observable
  originHeight = 0;
  @observable
  originWidth = 0;
  @observable
  isMiniProgram = false;

  constructor() {
    super();
    this.initIsMiniProgram();
  }

  @computed
  get isRedPacketSupport() {
    return utils.isFoApp() || +this.appConfig.h5_coupon_support > 0;
  }

  @computed
  get countryCodes() {
    return this.appConfig.area.map(item => {
      return {
        ...item,
        label: `${item.code} ${item.name}`,
        value: item.prefix
      };
    });
  }

  // ios10及以下对嵌入的h5 webview的高度解释有问题
  @action.bound
  initOriginHeight() {
    this.update({
      originHeight: window.innerHeight,
      originWidth: window.innerWidth
    });
  }

  @action.bound
  async fetchAppConfig() {
    const { _data } = await api.getAppConfig();
    if (_data) {
      this.update({
        appConfig: _data
      });
    }
  }

  @action.bound
  async initIsMiniProgram() {
    const isMini = await utils.isMiniProgram();
    runInAction(() => {
      this.isMiniProgram = isMini;
    });
  }
}

export default new StoreGlobal();



// WEBPACK FOOTER //
// ./src/store/storeGlobal.js